import React, { useEffect, useState, useContext } from "react";
import { collection, query, orderBy, getDocs } from "firebase/firestore";
import { formatDistanceToNow } from "date-fns";
import { AiOutlineClockCircle } from "react-icons/ai";
import "./pushnotification.css";
import { ProfileContext } from "../../context/ProfileContext";
import { db } from "../../firebase/FirebaseConfig";
import ProfileHeader from "../profile/components/ProfileHeader";
import { useOutletContext } from "react-router-dom";

const NotificationsPage = () => {
  const { user } = useContext(ProfileContext);
  let partnerTypee = user.type || '';
//   console.log(user);
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const { openSidebar } = useOutletContext();

  useEffect(() => {
    const fetchNotifications = async () => {
      if (!user?.partnerCode) return;

      setLoading(true);

      try {
        const clientCode = user.partnerCode;

        // 🔹 Fetch all notifications ordered by createdAt
        const q = query(
          collection(db, "notifications"),
          orderBy("createdAt", "desc")
        );
        const snap = await getDocs(q);

        // 🔹 Client-side filtering (Flutter-style)
        const filtered = snap.docs
          .map(doc => ({ id: doc.id, ...doc.data() }))
          .filter(notif => {
            const users = (notif.userIds || []).map(u => u.toString().trim());
            const partnerType = notif.partnerType;

            // Bulk notification
            if (users.length === 0 && partnerType === partnerTypee) return true;

            // Individual notification
            if (users.includes(clientCode)) return true;

            return false;
          });

        setNotifications(filtered);
      } catch (err) {
        console.error("Error fetching notifications:", err);
      }

      setLoading(false);
    };

    fetchNotifications();
  }, [user]);

  return (
    <div className="rp-create-leads-page">
    <ProfileHeader onMenuClick={openSidebar} val="Push Notifications" />
    <div className="notifications-page">
      
      {loading ? (
        <p className="loading-text">Loading...</p>
      ) : notifications.length === 0 ? (
        <p className="empty-text">No notifications</p>
      ) : (
        <div className="notifications-grid">
          {notifications.map(notif => (
            <div key={notif.id} className="notification-card">
              <div className="notif-image-wrapper">
                <img
                  src={notif.imageUrl || "/push_notification.avif"}
                  alt="Notification"
                  className="notif-image"
                />
              </div>
              <div className="notif-content">
                <h4 className="notif-title">{notif.title || "NA"}</h4>
                <p className="notif-body">{notif.body || "NA"}</p>
                <div className="notif-footer">
                  <AiOutlineClockCircle size={16} color="#888" />
                  <span className="notif-time">
                    {notif.createdAt?.toDate
                      ? formatDistanceToNow(notif.createdAt.toDate(), { addSuffix: true })
                      : ""}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
    </div>
  );
};

export default NotificationsPage;